import Header from "@/components/sections/Header";
import Hero from "@/components/sections/Hero";
import About from "@/components/sections/About";
import Services from "@/components/sections/Services";
import Gallery from "@/components/sections/Gallery";
import MapSection from "@/components/sections/MapSection";
import Contact from "@/components/sections/Contact";
import Footer from "@/components/sections/Footer";

export default function Home() {
  return (
    <main data-testid="home-page" className="bg-[#FAF9F6] text-[#1A3628] min-h-screen">
      <Header />
      <Hero />
      <About />
      <Services />
      <Gallery />
      <MapSection />
      <Contact />
      <Footer />
    </main>
  );
}
